import { LegalPage } from "@/components/legal/LegalPage";

export default function Terms() {
  return <LegalPage doc="terms" />;
}
